// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useEffect, useMemo} from 'react';
import hola_opt from 'hola_opt';
import {qs_parse} from 'zurl';
import {perr} from 'hola_pub_util';
import styles from './captcha.module.less';
import cn from 'classnames';
import {get_error_description} from '../ui/login/errors';

// eslint-disable-next-line
const noop = ()=>{};

const global_captcha:any = {};
// @ts-ignore
window.global_captcha = global_captcha;
// @ts-ignore
window.mt_jsloadedcb = ()=>{
    global_captcha.state = 'loaded';
    perr({id: 'www_mtcaptcha_loading_success'});
};
// @ts-ignore
window.mt_verifiedcb = ()=>{
    perr({id: 'www_mtcaptcha_challenge_done'});
    if (global_captcha.on_verified)
        global_captcha.on_verified();
};
// @ts-ignore
window.mt_renderedcb = ()=>{
    perr({id: 'www_mtcaptcha_challenge_show'});
};
// @ts-ignore
window.mt_errordcb = ()=>{
    perr({id: 'www_mtcaptcha_error'});
};
const qs_o = ()=>qs_parse(location.search.substr(1), {safe: true});
const is_toolip = location.host == 'toolip.io';
export const Captcha = ({on_verified, error_style, class_name='', error})=>{
    const mtcaptcha_generic_class = useMemo(()=>{
        return `mtcaptcha_${Math.round(Math.random()*1000)}`;
    }, []);
    useEffect(()=>{
        perr({id: 'www_mtcaptcha_loading_start'});
        const debug_mtcaptcha = qs_o().debug_mtcaptcha;
        const debug_mtcaptcha_visible = qs_o().debug_mtcaptcha_visible;
        global_captcha.on_verified = on_verified;
        if (global_captcha.state=='loading')
            return;
        if (global_captcha.state=='loaded')
        {
            // @ts-ignore
            window.mtcaptcha.resetUI(`${mtcaptcha_generic_class}`);
            // @ts-ignore
            window.mtcaptcha.renderUI(`${mtcaptcha_generic_class}`);
            global_captcha.mtcaptcha_generic_class = mtcaptcha_generic_class;
            return;
        }
        const toolip_style = {
            'cardBorder': '1px solid #E9E8E8',
            'cardBorderRadius': '4',
            'inputTextColor': '#676D73',
            'msgTextColor': '#777777',
            'invalidMsgTextColor': '#F74E39',
            'inputBackgroundColor': '#FFFFFF',
            'inputBorderColor': {
                'byDefault': '#BCDAFF',
                'hover': '#8EC4FF',
                'active': '#8EC4FF',
                'error': '#E37278',
            },
        };
        // @ts-ignore
        window.mtcaptchaConfig = {
            sitekey: hola_opt.mtcaptcha.site_key,
            'jsloaded-callback': 'mt_jsloadedcb',
            'verified-callback': 'mt_verifiedcb',
            'rendered-callback': 'mt_renderedcb',
            'error-callback': 'mt_errorcb',
            loadAnimation: 'false',
            theme: 'neowhite',
            widgetSize: 'mini',
            miniFormHeight: '48px',
            'customStyle': is_toolip ? toolip_style : {
                'cardBorder': '1px solid #E9E8E8',
                'cardBorderRadius': '4',
                'inputTextColor': '#444444',
                'msgTextColor': '#777777',
                'invalidMsgTextColor': '#F74E39',
                'inputBackgroundColor': '#F5F5F5',
                'inputBorderColor': {
                    'byDefault': '#E9E8E8',
                    'hover': '#B8B8B8',
                    'active': '#B8B8B8',
                },
            },
        };
        if (debug_mtcaptcha && debug_mtcaptcha_visible)
        {
            // @ts-ignore
            window.mtcaptchaConfig.lowFrictionInvisible = 'force-visible';
        }
        global_captcha.state = 'loading';
        (function(){
            const mt_service = document.createElement('script');
            mt_service.async = true;
            mt_service.id = 'mt_service_1';
            mt_service.src = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
            mt_service.onerror = ()=>{
                perr({id: 'www_mtcaptcha_loading_error'});
            };
            document.head.appendChild(mt_service);
            const mt_service2 = document.createElement('script');
            mt_service2.async = true;
            mt_service2.id = 'mt_service_1';
            mt_service2.src = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';
            mt_service.onerror = ()=>{
                perr({id: 'www_mtcaptcha_loading_error_2'});
            };
            document.head.appendChild(mt_service2);
        })();
        return ()=>{
            global_captcha.on_verified = undefined;
            try {
                // @ts-ignore
                window.mtcaptcha.remove(`${mtcaptcha_generic_class}`);
            } catch {}
        };
    }, [error && error.code]);
    return <div className={cn(styles.wrapper, class_name)}>
      <div className={cn('mtcaptcha', styles.root,
        error_style && styles.error_style)} key={mtcaptcha_generic_class}
        id={mtcaptcha_generic_class}>
      </div>
      {error_style && get_error_description(error.code, '', noop, ()=>'',
        false, false, styles.error)}
    </div>;
};
